import { render, staticRenderFns } from "./DetailHead.vue?vue&type=template&id=75674e32&scoped=true&"
import script from "./DetailHead.vue?vue&type=script&lang=js&"
export * from "./DetailHead.vue?vue&type=script&lang=js&"
import style0 from "./DetailHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailHead.vue?vue&type=style&index=1&id=75674e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75674e32",
  null
  
)

export default component.exports